import { refreshToken } from 'store/authentication/actions';
import { Store } from 'redux';
import { RootState } from 'store/types';

export class RefreshTokenManager {
  refreshPromise: ReturnType<typeof refreshToken> | null = null;

  isFrefreshing() {
    return !!this.refreshPromise;
  }

  refresh(store: Store<RootState>) {
    if (this.refreshPromise) {
      return this.refreshPromise;
    }

    this.refreshPromise = refreshToken(store.dispatch, store.getState()).then(response => {
      this.refreshPromise = null;

      return response;
    });

    return this.refreshPromise;
  }
}

export const dfdRefreshTokenManager = new RefreshTokenManager();
